import { dispatch } from '@store';
import { actions } from '@store/grids';

/**
 * Grids service.
 *
 * @author Mikhail Siutsou
 * @const GridsService
 * @category Components
 * @subcategory Grids
 */
var GridsService = {
  /**
   * Init grid.
   *
   * @author Mikhail Siutsou
   * @param {string} gridId gridId.
   * @param {array} items grid items.
   * @param {boolean} isLoading is grid loaded.
   * @param {boolean} isError fetch error.
   * @return {void}
   */
  init: function init(gridId, items, isLoading, isError) {
    dispatch(actions.gridInitRequest({
      gridId: gridId,
      items: items,
      isLoading: isLoading,
      isError: isError
    }));
  },

  /**
   * Update grid.
   *
   * @author Mikhail Siutsou
   * @param {string} gridId gridId.
   * @param {array} items grid items.
   * @param {boolean} isLoading is grid loaded.
   * @param {boolean} isError fetch error.
   * @return {void}
   */
  update: function update(gridId, items, isLoading, isError) {
    dispatch(actions.gridUpdateRequest({
      gridId: gridId,
      items: items,
      isLoading: isLoading,
      isError: isError
    }));
  },

  /**
   * Close grid.
   *
   * @author Mikhail Siutsou
   * @param {string} gridId gridId.
   * @return {void}
   */
  close: function close(gridId) {
    dispatch(actions.gridCloseRequest({
      gridId: gridId
    }));
  },

  /**
   * Close all grids.
   *
   * @author Mikhail Siutsou
   * @param {string} gridId gridId.
   * @return {void}
   */
  closeAll: function closeAll() {
    dispatch(actions.closeAllGridsRequest());
  },

  /**
   * Call grid api.
   *
   * @author Mikhail Siutsou
   * @param {string} gridId gridId.
   * @param {() => Promise<AxiosResponse<T | R> | ApiError> | Promise<T>} api grid api.
   * @param {((request: R) => T) | undefined} transformResponse grid transformer.
   * @return {Promise<AxiosResponse<T | R> | ApiError> | Promise<T>} items promise.
   */
  api: function api(gridId, _api, transformResponse) {
    var asyncDispatch = dispatch;
    return asyncDispatch(actions.gridApiFetch({
      gridId: gridId,
      api: _api,
      transformResponse: transformResponse
    }));
  },

  /**
   * Update grid api.
   *
   * @author Mikhail Siutsou
   * @param {string} gridId gridId.
   * @param {() => Promise<AxiosResponse<T | R> | ApiError> | Promise<T>} api grid api.
   * @param {((request: R) => T) | undefined} transformResponse grid transformer.
   * @return {Promise<AxiosResponse<T | R> | ApiError> | Promise<T>} items promise.
   */
  apiUpdate: function apiUpdate(gridId, api, transformResponse) {
    var asyncDispatch = dispatch;
    return asyncDispatch(actions.gridUpdateApiFetch({
      gridId: gridId,
      api: api,
      transformResponse: transformResponse
    }));
  }
};
export { GridsService };